module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-leaderboards-32.a969cef3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-leaderboards-32.png
// module id = 3197
// module chunks = 11